
//returns the computed stimuli positions for current trial
function computeStimuliPositions() {

	var screensCount = listTrialScreensTimings[trialRow].length;
	var posStimContainers = new Array();

	for (var screenIndex = 0; screenIndex < screensCount; screenIndex++) {
		var currentScreenTimings = listTrialScreensTimings[trialRow][screenIndex];
		computeImagesPosition(currentScreenTimings.startStimuliIndex, currentScreenTimings.startStimuliIndex + currentScreenTimings.stimuliNumber - 1);
    }

	return posStimContainers;

	function computeImagesPosition(fromIndex, toIndex) {
		if (toIndex === undefined) {
			toIndex = fromIndex - 1;
			fromIndex = 0;
		}

		if (toIndex < fromIndex) {
			return;
		}

		var keyImages = new Array();
		var n = toIndex - fromIndex + 1;

		for (var i = 1; i < n+1; i++) {
			var index = i + fromIndex;
			keyImages.push("image" + index);
		};

		var space = window['space' + n + 'images'];

		console.log('keyImages', keyImages);

		var blockSize = trialInfo[keyImages[0]].shiftInfo && trialInfo[keyImages[0]].shiftInfo.isStartBlock ? trialInfo[keyImages[0]].shiftInfo.blockSize : n;

		computeFirstStimulusPosition();

		var indexInBlock = 2;

		for (var is = 1; is < keyImages.length; is++) {
			var currentTrialToPosition = trialInfo[keyImages[is]];
			var prevTrial = trialInfo[keyImages[is-1]];

			//new block
			if (currentTrialToPosition.shiftInfo && currentTrialToPosition.shiftInfo.isStartBlock) {
				blockSize = currentTrialToPosition.shiftInfo.blockSize;
				indexInBlock = 1;
			}

			if (blockSize % 2) {
				//blocksize is odd
				//shift previous elements in the same block if we are not in a new block
				if (!currentTrialToPosition.shiftInfo || !currentTrialToPosition.shiftInfo.isStartBlock) {
					var horizShiftBy = space / 2 + currentTrialToPosition.halfWidth;
					// if block index start is not set then consider it to be 1
					var startBlockIndex = currentTrialToPosition.shiftInfo ? currentTrialToPosition.shiftInfo.fromIndex + 1 : 1;
					for (var iPrev = startBlockIndex; iPrev < is+1; iPrev++) {
						posStimContainers[iPrev + fromIndex].left = posStimContainers[iPrev + fromIndex].left - horizShiftBy;
					}

				}
			} else {
				//blocksize is even
				//if we haven't reached the latter part of the stimuli then shift previous elements in the same block if we are not in a new block
				if (indexInBlock <= blockSize / 2 + 1 && (!currentTrialToPosition.shiftInfo || !currentTrialToPosition.shiftInfo.isStartBlock)) {
					var horizShiftBy = indexInBlock <= blockSize / 2 ? space + currentTrialToPosition.width : space / 2;
					// if block index start is not set then consider it 1
					var startBlockIndex = currentTrialToPosition.shiftInfo ? currentTrialToPosition.shiftInfo.fromIndex + 1 : 1;

					//todo check here
					for (var iPrev = startBlockIndex; iPrev < is+1; iPrev++) {
						posStimContainers[iPrev + fromIndex].left = posStimContainers[iPrev + fromIndex].left - horizShiftBy;
					}
				}
			}

			indexInBlock++;

			console.log('posStimContainers', posStimContainers, is, fromIndex, currentTrialToPosition);
			posStimContainers[is + fromIndex + 1] = {};
			//is start of block ?
			if (currentTrialToPosition.shiftInfo && currentTrialToPosition.shiftInfo.isStartBlock) {
				// absolute position of stimuli center relative to screen center
				if (blockSize % 2) {
					posStimContainers[is + fromIndex + 1].left = halfCanvasWidth - currentTrialToPosition.width / 2 - borderImage + (currentTrialToPosition.horizShift ?  currentTrialToPosition.horizShift : 0);
				} else {
					posStimContainers[is + fromIndex + 1].left = halfCanvasWidth - currentTrialToPosition.width - borderImage + (currentTrialToPosition.horizShift ?  currentTrialToPosition.horizShift : 0);
				}

				posStimContainers[is + fromIndex + 1].top = halfCanvasHeight - currentTrialToPosition.halfHeight - borderImage + verticalShift + (currentTrialToPosition.vertShift ? currentTrialToPosition.vertShift : 0);
			} else {
				console.log(is, fromIndex, posStimContainers[is + fromIndex], posStimContainers[is + fromIndex].left);
				// position relative to the previous stimuli
				posStimContainers[is + fromIndex + 1].left = posStimContainers[is + fromIndex].left + space + prevTrial.width;
				// same top as previous stimuli
				posStimContainers[is + fromIndex + 1].top = posStimContainers[is + fromIndex].top;
			}

			posStimContainers[is + fromIndex + 1].height = currentTrialToPosition.height;
		}

		function computeFirstStimulusPosition() {
			posStimContainers[fromIndex + 1] = {};

			//set horizontal and vertical alignment
			// auto positioning
			if (blockSize % 2) {
				// start from the center of the scren (later it would be shifted to the left if it is part of block with multiple images)
				posStimContainers[fromIndex + 1].left = (halfCanvasWidth - trialInfo[keyImages[0]].width / 2 - borderImage);

				// horizontal absolute positioning relative to the center of the screen
				if (trialInfo[keyImages[0]].shiftInfo) {
					posStimContainers[fromIndex + 1].left = (halfCanvasWidth - trialInfo[keyImages[0]].width / 2 - borderImage + (trialInfo[keyImages[0]].horizShift ? trialInfo[keyImages[0]].horizShift : 0));
				}
			} else {
				// put image on the left of the screen
				posStimContainers[fromIndex + 1].left = (halfCanvasWidth - trialInfo[keyImages[0]].width - borderImage);

				if (trialInfo[keyImages[0]].shiftInfo) {
					posStimContainers[fromIndex + 1].left = (halfCanvasWidth - trialInfo[keyImages[0]].width - borderImage + (trialInfo[keyImages[0]].horizShift ? trialInfo[keyImages[0]].horizShift : 0));
				}
			}

			if (trialInfo[keyImages[0]].shiftInfo) {
				// stim has custom positioning via stimPos
				posStimContainers[fromIndex + 1].top = (halfCanvasHeight - trialInfo[keyImages[0]].halfHeight - borderImage + verticalShift + (trialInfo[keyImages[0]].vertShift ? trialInfo[keyImages[0]].vertShift : 0));
			} else {
				// auto layout
				// compute top based on the tallest image, so the entire block is aligned
				var maxHeightStimIndex = 0;
				var maxHeightStim = 0;

				for (var i = 0; i < blockSize; i++) {
					var keyImage = keyImages[i];
					if (trialInfo[keyImage].height>maxHeightStim) {
						maxHeightStim = trialInfo[keyImage].height;
						maxHeightStimIndex = i;
					}
				}

				posStimContainers[fromIndex + 1].top = (halfCanvasHeight - trialInfo[keyImages[maxHeightStimIndex]].halfHeight - borderImage + verticalShift + (trialInfo[keyImages[maxHeightStimIndex]].vertShift ? trialInfo[keyImages[maxHeightStimIndex]].vertShift : 0));
			}

			posStimContainers[fromIndex + 1].height = trialInfo[keyImages[0]].height;

			window.minImagesTop = posStimContainers[fromIndex + 1].top;
		}

	}
}

function computeStimuliBounds(posStimContainers, fromIndex = 0, count = 0) {

	var minTop = Number.POSITIVE_INFINITY;
	var maxTop = Number.NEGATIVE_INFINITY;
	var maxHeight = Number.NEGATIVE_INFINITY;
	var maxBottom = Number.NEGATIVE_INFINITY;
    
    if (count == 0) {
        count = posStimContainers.length;
    }

    for(let i = fromIndex + 1; i < fromIndex + count; i++) {
        let stimPos = posStimContainers[i];
    
		if(stimPos.height == 0){
			continue;
		}

		if (stimPos.top < minTop) {
			minTop = stimPos.top;
		}

		if (stimPos.top > maxTop) {
			maxTop = stimPos.top;
		}

		if (stimPos.height > maxHeight) {
			maxHeight = stimPos.height;
		}

		let currentBottom = stimPos.top + stimPos.height;
		if (currentBottom > maxBottom) {
			maxBottom = currentBottom;
		}
	}

	//consider mask top if mask is available
	if (columnForTrial('mask', trialRow) != 'na') {
		var maskTop = Math.round(halfCanvasHeight - imageMaskHeight/2 - borderImage);
		if (maskTop < minTop) {
			minTop = maskTop;
		}

		if (maskTop > maxTop) {
			maxTop = maskTop;
		}

		if (imageMaskHeight > maxHeight) {
			maxHeight = imageMaskHeight;
		}

		let currentBottom = maskTop + imageMaskHeight;
		if (currentBottom > maxBottom) {
			maxBottom = currentBottom;
		}
	}

	return {minTop: minTop, maxTop: maxTop, maxHeight: maxHeight, maxBottom: maxBottom};
}